import { useEffect, useState, forwardRef } from 'react';

import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch } from '../../app/hooks';
import { useTranslation } from 'react-i18next';
import { setURLPaths } from '../../app/organizationReducer';
import { RouteConstants } from '../../constants/RouteConstants';
import { NewOrganizationFormLayout, accountLockoutSchema } from '../../util/constants';

import LoaderContainer from '../shared/loaderContainer/LoaderContainer';

import Card from '../../components/shared/cards/Card';
import { HTTP_STATUS } from '../../http/constants/http.status';

import { SettingIcon } from '../../assets/components/svgs';
import { init } from 'i18next';
import { getAccountLockoutSettings } from '../../http/user-management-services';
import DynamicFormFieldRenderer from '../Reusable/DynamicFormFieldRenderer';
import ActionButtons from './ActionButtons';
import { handleSettingsValidation, validateSettingsSave } from './Utils';
import { isEmpty } from 'lodash';

const AccountLockOutPolicySettings = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [isReadOnly, setIsReadOnly] = useState(true);
  const [formData, setFormData] = useState<any>({});
  const [initialData, setInitialData] = useState({});
  const [formError, setFormError] = useState<any>({});
  const [inputSchema, setInpuSchema] = useState(accountLockoutSchema);

  useEffect(() => {
    const init = async () => {
      const accountLockOutSettings = await getAccountLockoutSettings();
      if (accountLockOutSettings.status === HTTP_STATUS.HTTP_OK) {
        const lockoutModeData = accountLockOutSettings.data;
        const { loginFailureLockoutMode } = lockoutModeData;
        setFormData({
          ...lockoutModeData,
          loginFailureLockoutMode: loginFailureLockoutMode.toString()
        });
        setIsLoading(false);
        setInitialData({
          ...lockoutModeData,
          loginFailureLockoutMode: loginFailureLockoutMode.toString()
        });
      }
    };
    dispatch(
      setURLPaths([
        {
          key: RouteConstants.ROUTE_SECURITY_SETTINGS_ACCOUNT_LOCKOUT,
          label: t('T_ACCESS_MANAGEMENT_SETTINGS')
        }
      ])
    );

    init();
  }, []);

  useEffect(() => {
    if (!isEmpty(formData)) {
      if (formData['loginFailureLockoutMode'] === 'true') {
        setInpuSchema(
          inputSchema.map((schema: any) => {
            //return { ...schema, style: { display: '' }, disableLabel: false };
            return { ...schema, disabled: false };
          })
        );
      } else {
        setInpuSchema(
          inputSchema.map((schema: any) => {
            //return { ...schema, style: { display: 'none' }, disableLabel: true };
            return { ...schema, disabled: true };
          })
        );
      }
    }
  }, [formData]);

  const resetSettings = () => {
    setFormData(initialData);
    setFormError({});
  };

  const postUpdateSettings = (respData: any) => {
    setInitialData(formData);
    setIsReadOnly(true);
    setIsLoading(false);
  };

  const handleValidation = () => {
    let formError = handleSettingsValidation(formData, inputSchema, t);
    setFormError(formError);
    return formError;
  };

  const validateSave = () => {
    return validateSettingsSave(formData, inputSchema);
  };

  const getPopOverContent = () => {
    return <div className="mt-10 text-justify leading-7">{t('T_ACCOUNT_LOCKOUT_POLICY_INFO')}</div>;
  };
  return (
    <LoaderContainer isLoading={isLoading}>
      <div className="flex w-3/5 flex-col overflow-visible px-2 py-3">
        <Card
          title={t('T_ACCOUNT_LOCKOUT_SETTINGS')}
          icon={SettingIcon}
          alt={'T_ACCOUNT_LOCKOUT_SETTINGS'}
          height={''}
          width={''}
          className=""
          actions={
            <ActionButtons
              settingKey={'accountLockout'}
              formData={formData}
              callback={postUpdateSettings}
              setIsReadOnly={setIsReadOnly}
              setIsLoading={setIsLoading}
              isReadOnly={isReadOnly}
              resetSettings={resetSettings}
              initialData={initialData}
              handleValidation={handleValidation}
              validateSave={validateSave}
            />
          }
          // popoverContent={getPopOverContent()}
          // popOverOnclick={true}
          // showModalHeader={false}
          // showCloseIcon={false}
        >
          <div className="mb-5 flex w-full flex-col flex-wrap">
            <div className="flex w-full flex-wrap">
              <DynamicFormFieldRenderer
                dynamicFormData={inputSchema}
                formData={formData}
                setFormData={setFormData}
                formError={formError}
                setFormError={setFormError}
                layout={NewOrganizationFormLayout.twoColumn}
                editable={!isReadOnly}
                disabled={isReadOnly}
              />
            </div>
          </div>
        </Card>
      </div>
    </LoaderContainer>
  );
};

export default AccountLockOutPolicySettings;
